import { useAuth0 } from '@auth0/auth0-react'
import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { QueryKeys } from '../../types'
import { getSymptomGraphs, getSymptomProgress } from './symptomProgress'
import { useSelectUserId } from '../../../../state/selectors'
import { SymptomGraphsResponse, SymptomProgressResponse } from '@estercare/ester-shared'

export const useGetSymptomProgressQuery = (): UseQueryResult<SymptomProgressResponse> => {
  const { getAccessTokenSilently } = useAuth0()
  const userId = useSelectUserId()

  return useQuery({
    queryKey: [QueryKeys.SymptomProgress, 'private', userId],
    queryFn: async () => {
      const accessToken = await getAccessTokenSilently()
      return await getSymptomProgress({ accessToken })
    },
  })
}

export const useGetSymptomGraphsQuery = (): UseQueryResult<SymptomGraphsResponse> => {
  const { getAccessTokenSilently } = useAuth0()
  const userId = useSelectUserId()

  return useQuery({
    queryKey: [QueryKeys.SymptomProgressGraphs, 'private', userId],
    queryFn: async () => {
      const accessToken = await getAccessTokenSilently()
      return await getSymptomGraphs({ accessToken })
    },
  })
}
